/* eslint-disable no-unused-vars */
import { ConfigProvider, Modal } from 'antd';
import srSR from 'antd/lib/locale/sr_RS';
import React from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import styled from 'styled-components';
import { useApplicationStateValue } from './context/ApplicationContext';
import { useAuthStateValue } from './context/AuthContext';
import BasicLayout from './layout/BasicLayout/BasicLayout';
import Login from './pages/login/Login';
import Register from './pages/register/Register';
import Verification from './pages/verification/Verification';
import BasicHeader from './layout/BasicHeader/BasicHeader';
import Dashboard from './pages/dashboard/Dashboard';
import { Route, Switch, Redirect } from 'react-router-dom';
import MonthyPlan from './pages/monthlyPlan/MonthyPlan';
import DailyPlan from './pages/dailyPlan/DailyPlan';
import Notifications from './pages/Notifications/Notifications';
import ChangeShift from './pages/changeShift/ChangeShift';
import PageNotFound from './pages/PageNotFound';
import RequestForChangeShift from './pages/changeShift/requestForChangeShift/RequestForChangeShift';
import ChangeShiftRequests from './pages/changeShift/changeShiftRequests/ChangeShiftRequests';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import confirmModal from './core/components/modals/ConfirmModal';

const Main = () => {
  const { isLoading } = useApplicationStateValue();
  const { loggedUser, isLoggedIn, logout } = useAuthStateValue();
  const { t } = useTranslation();
  const { language } = useApplicationStateValue();

  let lang = '';
  if (language === 'sr') {
    lang = srSR;
  } else {
    lang = null;
  }

  const history = useHistory()

  history.listen(() => {
    if (confirmModal.isOpen()) {
      confirmModal.destroy();
      history.go(1); // Cancel going back
    }
  });

  // Check if user has the specific ExtendUserDto structure for notifications-only access
  const isNotificationsOnlyUser = () => {
    const extendUser = loggedUser?.extendUser;
    return (
      extendUser?.workplace === "Korisnik" &&
      extendUser?.organizationalUnitName === "Korisnik sistema"
    );
  };

  const shouldShowNotificationsOnly = isNotificationsOnlyUser();

  return (
    <ConfigProvider locale={lang}>
        {isLoggedIn ? (<Wrapper>
          <BasicHeader/>
          
          <Switch>
            <Route path='/' exact component={Dashboard}></Route>
            <Route path='/monthlyPlan' component={MonthyPlan}></Route>
            <Route path='/dailyPlan' component={DailyPlan}></Route>
            <Route path='/changeShift' exact component={ChangeShift}></Route>
            <Route path={'/changeShift/requestForChangeShift'} component={RequestForChangeShift}></Route>
            <Route path={'/changeShift/changeShiftRequests'} component={ChangeShiftRequests}></Route>
            <Route path='/notifications' component={Notifications}></Route>
            <Route path='*' component={PageNotFound}></Route>
          </Switch>
          </Wrapper>) : (
          <Switch>
            <Route path='/' exact component={Login}></Route>
            <Route path='/register' component={Register}></Route>
            <Route path='/verification' component={Verification}></Route>
            <Route path='*' component={Login}></Route>
          </Switch>
        )}
      
    </ConfigProvider>
  );
};
export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #e6e6e6;
`
export default Main;
